export default __webpack_public_path__ + "static/media/coins-1.a3a1d32b.svg";